'use strict'

import DomUtils from 'helpers/dom-utils';

export default class Tooltips {

  constructor( props ) {
    this.className = 'tooltips';

    if(typeof props === 'object' && props){
      this.container = props.container ? props.container : null;
    }
  }

  tooltipContainers() {
    if(this.container != null){
      return document.querySelectorAll(`${this.container} .${this.className}-container`);
    } else {
      return document.querySelectorAll(`.${this.className}-container`);
    }
  }

  initStyles(){
    for(let tooltipContainer of this.tooltipContainers()){
      DomUtils.addClass(tooltipContainer.querySelector(`.${this.className}-content`), `${this.className}-content--js-loaded`);
    }
  }

  showTooltip( element ){
    DomUtils.addClass(element, `${this.className}-content--visible`);
  }

  hideTooltip( element ){
    DomUtils.removeClass(element, `${this.className}-content--visible`);
  }

  hideAllTooltips(){
    for(let tooltipContainer of this.tooltipContainers()){
      this.hideTooltip(tooltipContainer.querySelector(`.${this.className}-content`));
    }
  }


  setEventListeners() {

    if(DomUtils.isTouchDevice()){

      for(let tooltipContainer of this.tooltipContainers()){
        DomUtils.addClass(tooltipContainer, `${this.className}-container--touch`);
      }

      document.addEventListener('touchend', (event) => {

        event.stopPropagation();
        let element = event.target;

        if(event.target.classList.contains(`${this.className}-container`)){
          this.hideAllTooltips();
          this.showTooltip(element.querySelector(`.${this.className}-content`));
        }else{
          this.hideAllTooltips();
        }

      });

    }else{

      for(let tooltipContainer of this.tooltipContainers()){

        tooltipContainer.addEventListener('mouseenter', (event) => {
          let element = event.target;
          this.showTooltip(element.querySelector(`.${this.className}-content`));
        });

        tooltipContainer.addEventListener('mouseleave', (event) => {
          let element = event.target;
          for(tooltipContainer of this.tooltipContainers()){
            this.hideTooltip(element.querySelector(`.${this.className}-content`));
          }
        });

      }

    }

  }

  init() {
    this.initStyles();
    this.setEventListeners();
  }

}
